export const getQueryParam = (param: string) => new URLSearchParams(window.location.search).get(param);
